import React from 'react'
import PropTypes from 'prop-types'
import { NavLink, withRouter } from 'react-router-dom'

import Button from 'components/buttons/Button'
import FormWithActions from 'layout/FormWithActions'
import styles from './index.css'

@withRouter
export default class Delete extends React.Component {
  
  static propTypes = {
    entityName : PropTypes.string.isRequired,
    onConfirm : PropTypes.func,
    onCancel  : PropTypes.func,
  }

  static defaultProps = {
    onConfirm : () => {},
    onCancel  : () => {}
  }

  constructor(props) {
    super(props)
  }

  render() {
    return (
      <FormWithActions title='Confirm Delete'
        actions={[
          <Button key={0} onClick={this.props.onCancel} color='grey'>No</Button>
          ,
          <Button key={1} onClick={this.props.onConfirm} color='orange'>Yes</Button>
        ]}>
        <p style={{fontSize: '1.6rem'}}>Are you sure to delete {this.props.entityName}?</p>
        <br />
      </FormWithActions>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/Delete/index.jsx